import moment from "moment";

const convertDate = (date?: string, format = "DD MMMM YYYY") =>
  moment(date).format(format);

export default convertDate;
